import React from 'react';
import PropTypes from 'prop-types';

const Table = ({ children }) => (
  <div className='table'>
    {children}
  </div>
);

const Header = ({ headers }) => (
  <div className='table-header table-row'>
    {headers.map((header) => (
      <h3 className='table-header__item' key={header}>{header}</h3>
    ))}
  </div>
);

Header.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  headers: PropTypes.array.isRequired,
};

const Content = ({ children }) => (
  <div className='table-content'>
    {children}
  </div>
);

Content.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  children: PropTypes.element.isRequired,
};

Table.propTypes = {
  children: PropTypes.element.isRequired,
};

Table.Header = Header;
Table.Content = Content;

export default Table;
